// extracted by mini-css-extract-plugin
module.exports = {"introjs-highlightClass":"introjs-introjs-highlightClass__3DKXg"};